import React, {useEffect, useState} from "react";
import DownloadClientVcfButtonProperties from "./DownloadClientVcfButtonProperties";
import {Observer} from "mobx-react-lite";
import ButtonType from "../../../ui_components/Button/ButtonType";
import {Config} from "../../../util/Config";
import {RestClient} from "../../../util/RestClient";
import {Downloader} from "../../../util/Download";
import Button from "../../../ui_components/Button/Button";
import ButtonSize from "../../../ui_components/Button/ButtonSize";
import RoundedButton from "../../../ui_components/RoundedButton/RoundedButton";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const DownloadClientVcfButton: React.FC<DownloadClientVcfButtonProperties> = ({
                                                                                                clientId,
                                                                                                clientName,
                                                                                                className = '',
                                                                                                disabled = false,
                                                                                                rounded = false,
                                                                                                size = ButtonSize.DEFAULT,
                                                                                                type = ButtonType.DEFAULT,
                                                                                                showIcon = true,
                                                                                                showText = true,
                                                                                            }) => {


    const text = "Descargar VCard";
    const Btn = () => {
        if (rounded) {
            return <RoundedButton
                onClick={onClick}
                className={className}
                disabled={disabled}
                tooltip={!showText ? text : ""}
                text={showText ? text : ""}
                type={type}
                icon={showIcon ? <WhatsAppIcon/> : <></>}
            />
        }
        return <Button
            loading={loading}
            text={showText ? text : ""}
            className={className}
            tooltip={!showText ? text : ""}
            disabled={disabled}
            size={size}
            onClick={onClick}
            type={type}
            startIcon={showIcon ? <WhatsAppIcon/> : <></>}
        />
    }
    const getUrl = () => {
        return Config.get("GET_CLIENT_VCF_URL", {
            id: clientId
        })
    }
    const [url, setUrl] = useState(getUrl());
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const newUrl = getUrl();
        setUrl(newUrl);
        // eslint-disable-next-line
    }, [clientId]);

    const onClick = async () => {
        setLoading(true);
        const response = await RestClient.download(url);
        let fileName = `${clientName}.vcf`;
        if (response.success) {
            Downloader.download(response.data?.filename || fileName, response.data?.data);
        }
        setLoading(false);
    }
    return (
        <Observer>{() => (<Btn/>)}</Observer>
    );
};

export default DownloadClientVcfButton;
